import $ from 'jquery';
import 'bootstrap';

require ('./partial/home.js');
require ('./partial/our_work.js');
require ('./partial/header.js');
require ('./partial/pages.js');
require ('./partial/equipment.js');
require ('./partial/news-events.js');
require ('./partial/search.js');